export var SelectionType;
(function (SelectionType) {
    SelectionType["ML"] = "ML";
    SelectionType["OU"] = "OU";
    SelectionType["HC"] = "HC";
    SelectionType["QA"] = "QA";
})(SelectionType || (SelectionType = {}));
//# sourceMappingURL=SelectionType.js.map